<form #requestForm="ngForm" (ngSubmit)="save()">
  @if (error) { <div class="alert alert-danger" role="alert">{{ error }}</div> }
  <fieldset [disabled]="saving || member?.status != 0">
    <div [class.modal-body]="!inline" [class.row]="inline">
    @if (kind === 'start') {
      <div class="form-group" [class.col-md-6]="inline">
        <label class="col-form-label" for="subscriptionProduct">商品</label>
        <select id="subscriptionProduct" class="form-control" name="product" [(ngModel)]="product" required>
          <option [ngValue]="null">選択してください</option>
          @for (item of products; track item.id) { <option [ngValue]="item">(¥{{ price(item) | number:'1.0-0' }}) {{ item.name }}</option> }
        </select>
        @if (!products.length) { <small class="text-danger">申請可能な商品がありません。</small> }
      </div>
    } @else {
      <div class="form-group" [class.col-md-6]="inline">
        <label class="col-form-label" for="subscriptionContract">停止対象契約</label>
        <select id="subscriptionContract" class="form-control" name="subscription" [(ngModel)]="subscription" required>
          <option [ngValue]="null">選択してください</option>
          @for (item of activeSubscriptions; track item.id) { <option [ngValue]="item">{{ label(item) }}</option> }
        </select>
        @if (!activeSubscriptions.length) { <p class="text-muted">停止可能な契約がありません。</p> }
      </div>
    }
    <div class="form-group" [class.col-md-6]="inline">
      <label class="col-form-label" for="subscriptionMonth">{{ kind === 'start' ? '利用開始月' : '最終利用月' }}</label>
      <select id="subscriptionMonth" class="form-control" name="month" [(ngModel)]="month" required>
        <option value="">選択してください</option>
        @for (item of months; track item.value) { <option [value]="item.value">{{ item.name }}</option> }
      </select>
    </div>
    @if (kind === 'start') {
      <div class="form-group" [class.col-md-6]="inline">
        <label class="col-form-label" for="subscriptionDay">引渡日（毎月日）</label>
        <select id="subscriptionDay" class="form-control" name="deliveryDay" [(ngModel)]="deliveryDay">
          <option [ngValue]="null">未設定</option>
          @for (day of days; track day) { <option [ngValue]="day">{{ day }}日</option> }
        </select>
      </div>
      <div class="form-group subscription-terms-section" [class.col-md-12]="inline"><label class="col-form-label">利用規約</label>
      <div class="subscription-terms-box"><div class="subscription-terms-document">
        <h6>物販定期便利用規約</h6>
        <p>☐ 本サービスは、毎月1回、対象商品をご提供するサービスです。<br>
          ☐ 商品のお渡しは、毎月1日以降、ご来店の際にお渡しいたします。<br>
          ☐ 本サービスは、定期購入開始月から最低3ヶ月間のご契約が必要です。<br>
          ☐ 各種お手続きは毎月10日締め切りとなります。<br>
          10日を過ぎた場合のお手続きは、翌月の受付となります。<br>
          ☐本サービスは最低契約期間終了後、解約のお手続きがない限り自動更新されます。<br>
          ☐ 商品の保管期限は、お渡し対象月の末日までとします。<br>
          期限内にお受け取りいただけない場合、<br>
          商品を受け取る権利は失効するものとし、返金および翌月への繰り越しはできません。<br>
          ☐ 最低契約期間終了後、本サービスの解約をご希望の場合は、<br>
          解約希望月の前月10日までに、店舗にてお手続きください。<br>
          (例: 3月分から停止したい場合は、2月10日までにお手続きが必要です)</p>
      </div></div>
      <div class="form-check subscription-terms-agreement"><input id="subscriptionTerms" class="form-check-input" type="checkbox" name="termsAgreed" [(ngModel)]="termsAgreed" required><label class="form-check-label" for="subscriptionTerms">物販定期便利用規約に同意します。</label></div>
      @if (!termsAgreed) { <small class="text-danger">申請には利用規約への同意が必要です。</small> }
    </div>}
    </div>
    <div class="modal-footer justify-content-end">
    <button type="button" class="btn bg-close text-white" (click)="cancelled.emit()"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
    <button type="submit" class="btn btn-success" [disabled]="requestForm.invalid || saving || (kind === 'start' && !termsAgreed)">{{ saving ? '申請中…' : '申請' }}</button>
    </div>
  </fieldset>
</form>
